import { z } from "zod";

export const stringToJSONSchema = z.string().transform((str, ctx) => {
  try {
    return JSON.parse(str);
  } catch {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Invalid JSON" });
    return z.NEVER;
  }
});

/* export const googleTagManagerValidation = stringToJSONSchema.pipe(
  z.discriminatedUnion("isEnabled", [
    z.object({
      isEnabled: z.literal(true),
      tagManagerId: z.string(),
    }),
    z.object({
      isEnabled: z.literal(false),
    }),
  ])
);*/

export const googleTagManagerValidation = z.enum(["true", "false"]).transform((value) => value === "true");

export const posthogConfigValidation = stringToJSONSchema.pipe(
  z.discriminatedUnion("isEnabled", [
    z.object({
      debug: z.boolean(),
      isEnabled: z.literal(true),
      key: z.string(),
    }),
    z.object({
      isEnabled: z.literal(false),
    }),
  ])
);

export const deploymentEnvironmentValidation = z.enum(["localhost", "development", "staging", "production"]);

export const isMaintenanceModeValidation = z.enum(["true", "false"]).transform((value) => value === "true");

export const urlValidator = z.url().refine((url) => !url.endsWith("/"), {
  message: "urls must not end with a trailing slash",
});
